import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SimpleBarChart } from "../../ProductInventory/InventoryCharts";
import { getStoreStockValue } from "../../../redux/StoreManagement/storeManagementActions";

const StoreStockChart = () => {
  const dispatch = useDispatch();
  const {
    totalStockValue,
    totalSales,
    stockValueByLocation,
    salesByLocation,
    stockValueLoading,
  } = useSelector((state) => state.storeManagement);

  const [activeTab, setActiveTab] = useState("stock_value");
  const [period, setPeriod] = useState("1month");
  

  useEffect(() => {
    dispatch(getStoreStockValue({ filter_period: period }));
  }, [dispatch, period]);

  // Transform data for the chart based on active tab
  const getChartData = () => {
    if (activeTab === "stock_value") {
      return stockValueByLocation.map((location) => ({
        location: location.name?.length > 8 
          ? location.name.substring(0, 8) + "..." 
          : location.name,
        quantity_sold: location.stock_value || 0,
      }));
    } else {
      return salesByLocation.map((location) => ({
        location: location.name?.length > 8 
          ? location.name.substring(0, 8) + "..." 
          : location.name,
        quantity_sold: location.sales || 0,
      }));
    }
  };

  const chartData = getChartData();

  const tabs = [
    { id: "stock_value", label: "Stock Value" },
    { id: "sales", label: "Sales" },
  ];

  return (
    <div className="bg-white border border-[#E1E6E1] rounded-lg p-4">
      {/* Tab Navigation - Using Teammates Management Pattern */}
      <div className="flex items-center border border-[#E1E6E1] bg-[#F6F7F6] rounded-lg overflow-hidden w-full mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 text-sm flex-1 font-semibold ${
              activeTab === tab.id
                ? "bg-white text-[#161D17]"
                : "text-[#5F6D60]"
            } rounded-lg transition`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Stock Value Display */}
      {activeTab === "stock_value" && (
        <div className="mb-6 flex items-center justify-between">
          <div>
            <p className="text-[#5F6D60] text-sm font-semibold">Total Stock Value</p>
            <p className="text-[#344335] font-semibold text-2xl mt-1">
              {stockValueLoading ? "..." : `₦${totalStockValue.toLocaleString()}`}
            </p>
          </div>
           <div className="">
              <select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="text-sm font-semibold text-[#5F6D60] focus:outline-none focus:ring-0"
              >
                <option value="1month">1 Month</option>
                <option value="3months">3 Months</option>
                <option value="1year">1 Year</option>
              </select>
            </div>
        </div>
      )}

      {/* Sales Display */}
      {activeTab === "sales" && (
        <div className="mb-6 flex justify-between items-center">
          <div>
          <p className="text-[#5F6D60] text-sm font-semibold">Total Sales</p>
          <p className="text-[#344335] font-semibold text-2xl mt-1">
            {stockValueLoading ? "..." : `₦${totalSales.toLocaleString()}`}
          </p>
          </div>
          <div className="">
              <select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="text-sm font-semibold text-[#5F6D60] focus:outline-none focus:ring-0"
              >
                <option value="1month">1 Month</option>
                <option value="3months">3 Months</option>
                <option value="1year">1 Year</option>
              </select>
          </div>
        </div>
      )}

      {/* Chart */}
      <div className="h-80">
        {stockValueLoading ? (
          <div className="flex items-center justify-center h-full">
            <div className="animate-pulse">
              <div className="flex space-x-2">
                {[...Array(10)].map((_, index) => (
                  <div
                    key={index}
                    className="bg-gray-200 rounded"
                    style={{
                      width: "24px",
                      height: `${Math.random() * 100 + 50}px`,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : chartData.length > 0 ? (
          <SimpleBarChart data={chartData} />
        ) : (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#F6F7F6] rounded-full flex items-center justify-center">
                <svg 
                  className="w-8 h-8 text-[#5F6D60]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
                  />
                </svg>
              </div>
              <p className="text-[#5F6D60] text-sm">No {activeTab === "stock_value" ? "stock value" : "sales"} data available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoreStockChart;